// extracted by mini-css-extract-plugin
export var details = "project-details-module--details--1tNzN";
export var html = "project-details-module--html--3YwDw";